export default{
    host: process.env.VUE_APP_BE_HOST,
    WIDTH_OF_MOBILE:890,
}


